export enum InspectionRepeatOption {
    NO_REPEAT = 'NO_REPEAT',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}
